import React from 'react';
import styled from 'styled-components';
import ArrowIcon from '~/assets/button/arrow.svg';
import AllImagesIcon from '~/assets/button/all_images.png';
import AllVideosIcon from '~/assets/button/all_videos.png';
import AllFilesIcon from '~/assets/button/all_files.png';
import UploadIcon from '~/assets/button/upload.png';
import UnsplashIcon from '~/assets/button/unsplash.png';
import PexelsIcon from '~/assets/button/pexels.png';
import LibraryIcon from '~/assets/button/library.png';
import AiIcon from '~/assets/button/ai_b.png';

const Container = styled.div`
  width: 250px;
  padding-right: 20px;

  h3 {
    font-family: ralewayBold;
    font-weight: unset !important;
    font-size: 14px;
    line-height: 16.44px;
    letter-spacing: 0.1em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }

  ul {
    margin-top: 20px;
    li {
      padding: 8px;
      font-family: Raleway;
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      cursor: pointer;

      display: flex;
      justify-content: space-between;
      padding-left: 36px;

      svg {
        rotate: 180deg;
        margin-top: 5px;
        path {
          fill: #e0e0e0;
        }
      }
    }
    li.active {
      border-radius: 8px;
      background: #f5f5f5;

      svg {
        path {
          fill: #000;
        }
      }
    }
    li.all_files {
      background-image: url(${AllFilesIcon});
      background-size: 20px;
      background-repeat: no-repeat;
      background-position: 10px center;
    }
    li.all_images {
      background-image: url(${AllImagesIcon});
      background-size: 20px;
      background-repeat: no-repeat;
      background-position: 10px center;
    }
    li.all_videos {
      background-image: url(${AllVideosIcon});
      background-size: 20px;
      background-repeat: no-repeat;
      background-position: 10px center;
    }
    li.upload {
      background-image: url(${UploadIcon});
      background-size: 20px;
      background-repeat: no-repeat;
      background-position: 10px center;
    }
    li.unsplash {
      background-image: url(${UnsplashIcon});
      background-size: 20px;
      background-repeat: no-repeat;
      background-position: 10px center;
    }
    li.pexels {
      background-image: url(${PexelsIcon});
      background-size: 20px;
      background-repeat: no-repeat;
      background-position: 10px center;
    }
    li.ai {
      background-image: url(${AiIcon});
      background-size: 20px;
      background-repeat: no-repeat;
      background-position: 10px center;
    }
    li.easyllama {
      background-image: url(${LibraryIcon});
      background-size: 20px;
      background-repeat: no-repeat;
      background-position: 10px center;
    }
  }
`;

export type MenuItem = {
  title: string;
  active: boolean;
  className: string;
};

type LeftMenuProps = {
  children?: React.ReactNode;
  menu: MenuItem[];
  onMenuItemClick: (item: MenuItem) => void;
};

const LeftMenu: React.FC<LeftMenuProps> = ({
  menu,
  onMenuItemClick,
  children
}) => {
  return (
    <Container>
      <h3>SELECT YOUR MEDIA</h3>
      <ul>
        {menu.map(item => (
          <li
            className={`${item.className} ${item.active ? 'active' : ''}`}
            key={item.className}
            onClick={() => onMenuItemClick(item)}
          >
            {item.title}
            <ArrowIcon />
          </li>
        ))}
      </ul>
      {children}
    </Container>
  );
};

export default LeftMenu;
